module.exports = __webpack_public_path__ + "img/ring_r_s_0_null@2x.da02f9de.png";